import importView from '../../views/contract/contract-import.vue';
import query from '../../views/contract/contract-query.vue';
import informationMsg from '../../views/contract/contract-information-msg.vue';
var contract = [
    {
        name: 'contractImport',
        path: 'import',
        component: importView,
    },
    {
        name: 'contractQuery',
        path: 'query',
        component: query,
    },
    {
        name: 'contractInformationMsg',
        path: 'information-msg',
        component: informationMsg,
    },
];
export default contract;
